import {CategoryKind, CreateProduct} from "./CreateProduct";
import {Product} from "../../../../api/Products";
import {useAsync2} from "nate-react-api-helpers";
import {api} from "../../../../api/API";
import {Button, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";

export function ProductEdit(props: {
    value: Product;
    mode: CategoryKind;
    onClose(value?: Product): void;
}) {

    return <CreateProduct
        edit={props.value}
        mode={props.mode}
        onDone={(value: Product) => props.onClose(value)}
        onCancel={() => props.onClose()} />
}

export function ProductEditFromId(props: {
    id: number;
    mode?: CategoryKind;
    onClose(value?: Product): void;
}) {
    const productReq = useAsync2((input) => api.products.getById(input.id), {id: props.id}, [props.id]);
    const value = productReq.result;

    if(productReq.loadingOrError || !value) {
        return <Dialog2 open onClose={() => props.onClose()}>
            <DialogTitle>Loading</DialogTitle>
            <DialogContent>
                {productReq.LoadingOrErrorElement}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.onClose()}>Cancel</Button>
            </DialogActions>
        </Dialog2>
    }

    return <CreateProduct
        edit={value}
        mode={props.mode || value.kind}
        onDone={(value: Product) => props.onClose(value)}
        onCancel={() => props.onClose()} />
}